import styled from "styled-components";

export const Container = styled("div")`
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: space-between;
  text-align: center;
  padding: 20px;
  flex: 1;
`;

export const Content = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
`;

export const ImageSuccess = styled("img")`
  height: 300px;
  display: flex;
  align-content: center;
  justify-content: center;
  object-fit: contain;
  margin: 0 auto;
`;
